import { LazyQueryResultTuple, QueryResult } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Jumbo } from '@treams/treams-ui';

import GoalsList, { GoalsQuery } from './GoalsList';
import NewGoalButton from './NewGoalButton';

export default function UserGoals(props: { userID: string }) {
	const { t } = useTranslation();

	const userQuery = graphql.useUserQuery({ variables: { id: props.userID } });

	const query = graphql.useIndividualGoalsQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Active, last: 10 },
		fetchPolicy: 'network-only',
	});
	const completedQuery = graphql.useIndividualGoalsQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Completed, last: 10 },
		fetchPolicy: 'network-only',
	});
	const archivedQuery = graphql.useIndividualGoalsLazyQuery({
		variables: { id: props.userID, status: graphql.GoalStatus.Archived, last: 10 },
		fetchPolicy: 'network-only',
	});

	return (
		<>
			<Jumbo
				alignItems="center"
				title={
					userQuery.data
						? t('individual.goals.index.title', {
								name: userQuery.data.user.firstName,
							})
						: ''
				}
				button={userQuery.data?.user.viewerCanCreateGoal && <NewGoalButton userID={props.userID} />}
			/>
			<GoalsList
				query={query as QueryResult<GoalsQuery>}
				path="user.goalsV2"
				completedQuery={completedQuery as QueryResult<GoalsQuery>}
				user={(query.data?.user ?? completedQuery.data?.user) as graphql.User}
				archivedQuery={archivedQuery as LazyQueryResultTuple<GoalsQuery, object>}
				reorderable={false}
			/>
		</>
	);
}
